import type { Language } from "../config/site";

export const homeContent = {
  en: {
    eyebrow: "A daily logic ritual",
    headline: "Find the code.\nOpen the vault.",
    intro: "VaultPin turns deduction into a calm, precise daily challenge. Every clue narrows the possibilities—your next move is yours.",
    primaryAction: "Explore the Daily Vault",
    secondaryAction: "Get support",
    dailyLabel: "DAILY VAULT",
    dailyTitle: "One shared code. One attempt at a cleaner solve.",
    dailyBody: "A new four-digit vault opens worldwide at 16:00 UTC. Digits never repeat, and every guess returns clear positional feedback.",
    practiceLabel: "PRACTICE",
    practiceTitle: "Build your instinct at your own pace.",
    practiceBody: "Practice stays on your iPhone. Start with four digits, then move through Medium, Hard and Expert as your logic sharpens.",
    difficulties: ["Easy · 4", "Medium · 5", "Hard · 6", "Expert · 7"],
    purchaseTitle: "One purchase. No subscription.",
    purchaseBody: "Medium, Hard and Expert practice modes unlock together with one non-consumable StoreKit purchase. Restore is handled by Apple.",
    privacyTitle: "Designed without the usual noise.",
    privacyBody: "No advertising, analytics, tracking or third-party crash SDK. Practice progress and personal preferences remain on your device.",
    webTitle: "The web vault will open later.",
    webBody: "VaultPin is currently a native iOS game. This site is ready to welcome a web version in a future release—without pretending it is here today.",
    webAction: "About the web version",
  },
  tr: {
    eyebrow: "Günlük bir mantık ritüeli",
    headline: "Kodu bul.\nKasayı aç.",
    intro: "VaultPin, çıkarım yapmayı sakin ve net bir günlük mücadeleye dönüştürür. Her ipucu olasılıkları azaltır; sonraki hamle senindir.",
    primaryAction: "Günlük Kasa'yı keşfet",
    secondaryAction: "Destek al",
    dailyLabel: "GÜNLÜK KASA",
    dailyTitle: "Tek ortak kod. Daha temiz bir çözüm için tek oyun.",
    dailyBody: "Dört haneli yeni kasa her gün dünya genelinde 16:00 UTC'de açılır. Rakamlar tekrarlanmaz ve her tahmin net konum geri bildirimi verir.",
    practiceLabel: "PRATİK",
    practiceTitle: "İçgüdünü kendi hızında geliştir.",
    practiceBody: "Pratik oyunlar iPhone'unda kalır. Dört haneyle başla; mantığın güçlendikçe Orta, Zor ve Uzman seviyelerine ilerle.",
    difficulties: ["Kolay · 4", "Orta · 5", "Zor · 6", "Uzman · 7"],
    purchaseTitle: "Tek satın alma. Abonelik yok.",
    purchaseBody: "Orta, Zor ve Uzman pratik modları tek bir tüketilmeyen StoreKit satın alımıyla birlikte açılır. Geri yüklemeyi Apple yönetir.",
    privacyTitle: "Alışılmış gürültü olmadan tasarlandı.",
    privacyBody: "Reklam, analytics, tracking veya üçüncü taraf crash SDK'sı yoktur. Pratik ilerlemesi ve kişisel tercihler cihazında kalır.",
    webTitle: "Web kasası daha sonra açılacak.",
    webBody: "VaultPin şu anda native bir iOS oyunudur. Bu site, bugün varmış gibi davranmadan gelecekteki web sürümünü karşılamaya hazırdır.",
    webAction: "Web sürümü hakkında",
  },
} satisfies Record<Language, Record<string, string | string[]>>;
